import React, { useState } from 'react'
import { TooltipBubble } from './styled-components-tooltip'

export const TooltipWrapper = ({ tooltip, children, style }) => {
	const [pos, setPos] = useState(null)

	return (
		<div
			onMouseMove={
				tooltip
					? e => setPos({ x: e.clientX + 12, y: e.clientY + 16 })
					: undefined
			}
			onMouseLeave={tooltip ? () => setPos(null) : undefined}>
			{children}
			{tooltip && pos && (
				<TooltipBubble style={{ left: pos.x, top: pos.y }}>
					{tooltip}
				</TooltipBubble>
			)}
		</div>
	)
}
